"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.function.name");
var _SecKillTablePane = _interopRequireDefault(require("./SecKillTablePane.vue"));
var _SecKillConfig = _interopRequireDefault(require("./SecKillConfig.vue"));
var _SecKillOrderPane = _interopRequireDefault(require("./SecKillOrderPane.vue"));
var _SecKillRefundPane = _interopRequireDefault(require("./SecKillRefundPane.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SecKill',
  components: {
    SecKillTablePane: _SecKillTablePane.default,
    SecKillConfigPane: _SecKillConfig.default,
    SecKillOrderPane: _SecKillOrderPane.default,
    SecKillRefundPane: _SecKillRefundPane.default
  },
  data: function data() {
    return {
      activeName: 'seckill_table',
      currentId: null,
      isEdit: false,
      showConfigTab: false,
      configKey: 0,
      orderTabs: [],
      refundTabs: []
    };
  },
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
    },
    handleTabRemove: function handleTabRemove(targetName) {
      if (targetName === 'seckill_config') {
        this.showConfigTab = false;
        this.activeName = 'seckill_table';
        this.currentId = null;
        this.isEdit = false;
        return;
      }
      // 关闭订单 Tab
      var orderIdx = this.orderTabs.findIndex(function (t) {
        return t.name === targetName;
      });
      if (orderIdx > -1) {
        this.orderTabs.splice(orderIdx, 1);
        if (this.activeName === targetName) this.activeName = 'seckill_table';
        return;
      }
      // 关闭退款 Tab
      var refundIdx = this.refundTabs.findIndex(function (t) {
        return t.name === targetName;
      });
      if (refundIdx > -1) {
        this.refundTabs.splice(refundIdx, 1);
        if (this.activeName === targetName) this.activeName = 'seckill_table';
      }
    },
    handleToSecKillConfig: function handleToSecKillConfig(id) {
      var _this = this;
      this.currentId = id;
      this.isEdit = !!id;
      this.showConfigTab = true;
      this.configKey++;
      this.$nextTick(function () {
        _this.activeName = 'seckill_config';
      });
    },
    handleToSecKillOrder: function handleToSecKillOrder(payload) {
      var id = payload.id,
        title = payload.title;
      var existing = this.orderTabs.find(function (t) {
        return t.activityId === id;
      });
      if (existing) {
        this.activeName = existing.name;
        return;
      }
      var name = "seckill_order_".concat(id);
      this.orderTabs.push({
        name: name,
        title: "\u5168\u90E8\u8BA2\u5355 - ".concat(title),
        activityId: id,
        activityTitle: title
      });
      this.activeName = name;
    },
    handleToSecKillRefund: function handleToSecKillRefund(payload) {
      var id = payload.id,
        title = payload.title;
      var existing = this.refundTabs.find(function (t) {
        return t.activityId === id;
      });
      if (existing) {
        this.activeName = existing.name;
        return;
      }
      var name = "seckill_refund_".concat(id);
      this.refundTabs.push({
        name: name,
        title: "\u9000\u6B3E\u8BA2\u5355 - ".concat(title),
        activityId: id,
        activityTitle: title
      });
      this.activeName = name;
    },
    handleSuccess: function handleSuccess() {
      this.showConfigTab = false;
      this.activeName = 'seckill_table';
      this.currentId = null;
      this.isEdit = false;
      this.$refs.seckill_table.fetchData();
    },
    handleCancel: function handleCancel() {
      this.showConfigTab = false;
      this.activeName = 'seckill_table';
    }
  }
};